(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const staticFallbacks = new Map([
    ["assets/figma-swris-fv-transform.gif", "assets/figma-swris-fv-03.png"],
    ["assets/figma-morby-transform.gif", "assets/figma-morby-video-raw-02.png"],
  ]);

  const getDisplaySrc = (src) => (reduceMotion && staticFallbacks.has(src) ? staticFallbacks.get(src) : src);

  const setImage = (target, source) => {
    const src = source.dataset.motionSrc || source.getAttribute("src");
    const displaySrc = getDisplaySrc(src);

    target.setAttribute("src", displaySrc);
    target.dataset.motionSrc = src;
    target.setAttribute("alt", source.getAttribute("alt") || "");
    target.classList.remove("is-variant-product-image");
    target.classList.toggle("pdp-image--contain", source.classList.contains("pdp-image--contain"));
    target.classList.toggle("lullme-v2-image--contain", source.classList.contains("lullme-v2-image--contain"));
    target.classList.toggle("lullme-swris-image--contain", source.classList.contains("lullme-swris-image--contain"));
    target.style.objectPosition = source.dataset.imagePosition || source.style.objectPosition || "center center";
  };

  const setSelected = (buttons, index) => {
    buttons.forEach((button, buttonIndex) => {
      const selected = buttonIndex === index;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-selected", String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
  };

  const moveFocus = (buttons, nextIndex) => {
    const safeIndex = (nextIndex + buttons.length) % buttons.length;
    buttons[safeIndex].focus();
    buttons[safeIndex].click();
  };

  const bindKeyboard = (buttons) => {
    buttons.forEach((button, index) => {
      button.addEventListener("keydown", (event) => {
        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          event.preventDefault();
          moveFocus(buttons, index + 1);
        }
        if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          event.preventDefault();
          moveFocus(buttons, index - 1);
        }
        if (event.key === "Home") {
          event.preventDefault();
          moveFocus(buttons, 0);
        }
        if (event.key === "End") {
          event.preventDefault();
          moveFocus(buttons, buttons.length - 1);
        }
      });
    });
  };

  document.querySelectorAll('[data-media-gallery][data-gallery-variant="standard"]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === "true") return;

    const figures = Array.from(gallery.querySelectorAll("figure"));
    const images = figures.map((figure) => figure.querySelector("img")).filter(Boolean);
    const mainImage = gallery.querySelector(".pdp-gallery__main img") || images[0];
    if (!mainImage || images.length < 2) return;

    gallery.dataset.galleryReady = "true";
    const thumbs = document.createElement("div");
    thumbs.className = "pdp-gallery-thumbs";
    thumbs.setAttribute("role", "tablist");
    thumbs.setAttribute("aria-label", "商品画像を選択");

    const buttons = images.map((image, index) => {
      const button = document.createElement("button");
      const thumbImage = image.cloneNode(false);
      thumbImage.removeAttribute("id");
      thumbImage.setAttribute("alt", "");

      button.type = "button";
      button.className = "pdp-gallery-thumb";
      button.setAttribute("role", "tab");
      button.setAttribute("aria-label", `${index + 1}枚目の商品画像を表示`);
      button.append(thumbImage);
      button.addEventListener("click", () => {
        setImage(mainImage, image);
        setSelected(buttons, index);
      });
      thumbs.append(button);
      return button;
    });

    if (gallery.closest(".pdp-v2-page")) {
      gallery.after(thumbs);
    } else {
      gallery.append(thumbs);
    }
    document.addEventListener("shopify:block:select", (event) => {
      const index = images.findIndex((image) => image.dataset.galleryBlockId === event.detail?.blockId);
      if (index >= 0) buttons[index]?.click();
    });
    bindKeyboard(buttons);
    setSelected(buttons, 0);
  });

  document.querySelectorAll('[data-media-gallery][data-gallery-variant="morby"]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === "true") return;

    const thumbs = gallery.querySelector(".morby-figma-thumbs");
    const mainImage = gallery.querySelector(".morby-figma-main-image img");
    if (!thumbs || !mainImage) return;

    const thumbImages = Array.from(thumbs.querySelectorAll(":scope > img"));
    if (thumbImages.length < 2) return;

    gallery.dataset.galleryReady = "true";
    thumbs.setAttribute("role", "tablist");
    thumbs.setAttribute("aria-label", "商品画像を選択");

    const buttons = thumbImages.map((image, index) => {
      const button = document.createElement("button");
      const thumbImage = image.cloneNode(false);
      const src = image.getAttribute("src");
      thumbImage.setAttribute("src", getDisplaySrc(src));
      thumbImage.dataset.motionSrc = src;
      thumbImage.setAttribute("alt", "");

      button.type = "button";
      button.className = "morby-figma-thumb";
      button.setAttribute("role", "tab");
      button.setAttribute("aria-label", `${index + 1}枚目の商品画像を表示`);
      button.append(thumbImage);
      button.addEventListener("click", () => {
        setImage(mainImage, thumbImage);
        setSelected(buttons, index);
      });

      image.replaceWith(button);
      return button;
    });

    const previous = thumbs.querySelector("button:first-child:not(.morby-figma-thumb)");
    const next = thumbs.querySelector("button:last-child:not(.morby-figma-thumb)");
    let currentIndex = 0;

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        currentIndex = index;
      });
    });

    previous?.addEventListener("click", () => {
      moveFocus(buttons, currentIndex - 1);
    });
    next?.addEventListener("click", () => {
      moveFocus(buttons, currentIndex + 1);
    });

    bindKeyboard(buttons);
    setSelected(buttons, 0);
  });

  document.querySelectorAll('[data-media-gallery][data-gallery-variant="swris"]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === "true") return;

    const thumbs = gallery.querySelector(".swris-thumbs");
    const mainImage = gallery.querySelector(".swris-main-image img");
    if (!thumbs || !mainImage) return;

    const thumbImages = Array.from(thumbs.querySelectorAll(":scope > img"));
    if (thumbImages.length < 2) return;

    gallery.dataset.galleryReady = "true";
    thumbs.setAttribute("role", "tablist");
    thumbs.setAttribute("aria-label", "商品画像を選択");

    const previous = thumbs.querySelector(":scope > button:first-child");
    const next = thumbs.querySelector(":scope > button:last-child");
    let currentIndex = 0;

    const buttons = thumbImages.map((image, index) => {
      const button = document.createElement("button");
      const thumbImage = image.cloneNode(false);

      thumbImage.setAttribute("alt", "");
      button.type = "button";
      button.className = "swris-gallery-thumb";
      button.setAttribute("role", "tab");
      button.setAttribute("aria-label", `${index + 1}枚目の商品画像を表示`);
      button.append(thumbImage);
      button.addEventListener("click", () => {
        currentIndex = index;
        setImage(mainImage, thumbImage);
        setSelected(buttons, index);
      });

      image.replaceWith(button);
      return button;
    });

    previous?.addEventListener("click", () => moveFocus(buttons, currentIndex - 1));
    next?.addEventListener("click", () => moveFocus(buttons, currentIndex + 1));
    document.addEventListener("shopify:block:select", (event) => {
      const button = buttons.find((item) => item.querySelector(`[data-gallery-block-id="${event.detail?.blockId || ''}"]`));
      button?.click();
    });
    bindKeyboard(buttons);
    setSelected(buttons, 0);
  });

  document.querySelectorAll('[data-media-gallery][data-gallery-variant="lullme"]').forEach((gallery) => {
    if (gallery.dataset.galleryReady === "true") return;

    const thumbs = gallery.querySelector("[data-gallery-thumbs]");
    const mainImage = gallery.querySelector("[data-gallery-main] img");
    if (!thumbs || !mainImage) return;

    const thumbImages = Array.from(thumbs.querySelectorAll(":scope > img"));
    if (thumbImages.length < 2) return;

    gallery.dataset.galleryReady = "true";
    thumbs.setAttribute("role", "tablist");
    thumbs.setAttribute("aria-label", "商品画像を選択");

    const previous = thumbs.querySelector(":scope > button:first-child");
    const next = thumbs.querySelector(":scope > button:last-child");
    let currentIndex = 0;

    const buttons = thumbImages.map((image, index) => {
      const button = document.createElement("button");
      const thumbImage = image.cloneNode(false);
      thumbImage.setAttribute("alt", "");
      button.type = "button";
      button.className = gallery.classList.contains("lullme-v2-gallery") ? "lullme-v2-thumb" : "lullme-swris-thumb";
      button.setAttribute("role", "tab");
      button.setAttribute("aria-label", `${index + 1}枚目の商品画像を表示`);
      button.append(thumbImage);
      button.addEventListener("click", () => {
        currentIndex = index;
        setImage(mainImage, thumbImage);
        setSelected(buttons, index);
      });
      image.replaceWith(button);
      return button;
    });

    previous?.addEventListener("click", () => moveFocus(buttons, currentIndex - 1));
    next?.addEventListener("click", () => moveFocus(buttons, currentIndex + 1));
    document.addEventListener("shopify:block:select", (event) => {
      const button = buttons.find((item) => item.querySelector(`[data-gallery-block-id="${event.detail?.blockId || ''}"]`));
      button?.click();
    });
    bindKeyboard(buttons);
    setSelected(buttons, 0);
  });

  if (reduceMotion) {
    document.querySelectorAll("img").forEach((image) => {
      const src = image.dataset.motionSrc || image.getAttribute("src");
      if (staticFallbacks.has(src)) {
        image.dataset.motionSrc = src;
        image.setAttribute("src", staticFallbacks.get(src));
      }
    });
  }
})();

(() => {
  document.querySelectorAll("[data-product-root]").forEach((productRoot) => {
    productRoot.querySelectorAll("[data-product-option]").forEach((optionRoot) => {
      const buttons = Array.from(optionRoot.querySelectorAll("[data-option-value]"));
      const selectedLabel = optionRoot.querySelector("[data-selected-option]");
      if (!buttons.length) return;

      const selectOption = (button, emitChange = true) => {
        buttons.forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle("is-selected", selected);
          candidate.setAttribute("aria-checked", String(selected));
          candidate.tabIndex = selected ? 0 : -1;
        });

        const value = button.dataset.optionValue || button.textContent.trim();
        if (selectedLabel) selectedLabel.textContent = value;

        if (optionRoot.dataset.productOption === "Color") {
          productRoot.querySelectorAll("[data-selected-variant]").forEach((label) => {
            label.textContent = `カラー / ${value}`;
          });
        }

        if (emitChange) {
          productRoot.dispatchEvent(new CustomEvent("product:option-change", {
            bubbles: true,
            detail: {
              name: optionRoot.dataset.productOption,
              value,
              sku: button.dataset.variantSku || "",
            },
          }));
        }
      };

      buttons.forEach((button, index) => {
        button.addEventListener("click", () => selectOption(button));
        button.addEventListener("keydown", (event) => {
          let nextIndex = null;
          if (event.key === "ArrowRight" || event.key === "ArrowDown") nextIndex = index + 1;
          if (event.key === "ArrowLeft" || event.key === "ArrowUp") nextIndex = index - 1;
          if (event.key === "Home") nextIndex = 0;
          if (event.key === "End") nextIndex = buttons.length - 1;
          if (nextIndex === null) return;

          event.preventDefault();
          const nextButton = buttons[(nextIndex + buttons.length) % buttons.length];
          selectOption(nextButton);
          nextButton.focus();
        });
      });

      selectOption(buttons.find((button) => button.classList.contains("is-selected")) || buttons[0], false);
    });
  });
})();

(() => {
  document.querySelectorAll("[data-scene-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-scene-track]");
    const previous = carousel.querySelector("[data-scene-prev]");
    const next = carousel.querySelector("[data-scene-next]");
    if (!track || !previous || !next) return;

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const progress = max ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
      carousel.style.setProperty("--scene-progress", progress.toFixed(4));
      previous.disabled = progress <= 0.002;
      next.disabled = progress >= 0.998 || max === 0;
    };

    const move = (direction) => {
      const card = track.querySelector("figure");
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * distance, behavior: "smooth" });
    };

    previous.addEventListener("click", () => move(-1));
    next.addEventListener("click", () => move(1));
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
})();

(() => {
  document.querySelectorAll("[data-details-scroller]").forEach((track) => {
    const resetToStart = () => {
      track.scrollLeft = 0;
    };

    resetToStart();
    requestAnimationFrame(() => requestAnimationFrame(resetToStart));
    window.addEventListener("load", resetToStart, { once: true });
    window.addEventListener("pageshow", resetToStart);
  });
})();
